// Meta Pixel Event Tracking Utility
// Tracks: PageView, Lead, InitiateCheckout, Purchase

export const MetaPixel = {
  // Track a lead (form submission, quiz completion)
  trackLead: (data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: data.content_name || 'Lead Form',
        content_category: data.content_category || 'Visa Services',
        ...data
      });
      console.log('📊 Meta Pixel: Lead tracked', data);
    }
  },

  // Track when user starts checkout
  trackInitiateCheckout: (data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: data.plan_name || 'Plan',
        content_category: 'Visa Services',
        content_ids: [data.plan_id],
        value: data.price || 0,
        currency: 'USD',
        num_items: 1,
        ...data
      });
      console.log('📊 Meta Pixel: InitiateCheckout tracked', data);
    }
  },

  // Track a purchase
  trackPurchase: (data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Purchase', {
        content_name: data.plan_name || 'Plan',
        content_category: 'Visa Services',
        content_ids: [data.plan_id],
        content_type: 'product',
        value: data.price || 0,
        currency: 'USD',
        num_items: 1,
        ...data
      });
      console.log('📊 Meta Pixel: Purchase tracked', data);
    }
  },

  // Track custom events (quiz start, quiz complete, etc.)
  trackCustom: (eventName, data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', eventName, data);
      console.log(`📊 Meta Pixel: ${eventName} tracked`, data);
    }
  },

  // Track page view with custom data
  trackPageView: (data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView', data);
    }
  },

  // Track when user views content
  trackViewContent: (data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: data.content_name,
        content_category: data.content_category || 'Visa Services',
        value: data.value || 0,
        currency: 'USD',
        ...data
      });
    }
  },

  // Track contact/consultation request
  trackContact: (data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Contact', {
        content_name: data.content_name || 'Contact Request',
        ...data
      });
      console.log('📊 Meta Pixel: Contact tracked', data);
    }
  }
};

export default MetaPixel;
